import { gql } from 'graphql-request'

export const CREATE_SALE_CHANNELS = gql`
  mutation CreateSaleChannel($createSaleChannelInput: CreateSaleChannelInput!) {
    createSaleChannel(createSaleChannelInput: $createSaleChannelInput) {
      id
    }
  }
`
